import React from "react"

import{
   XCircleIcon
}from "@heroicons/react/24/outline"

function STPopup(props) {
        
    const closePopup = (e) =>{        
        e.preventDefault();
        props.setTrigger(false)
       
    }
    
    return (props.trigger)? (
        <div className='popupContainer'>                        
            <div className='w-1/4 h-60 bg-white rounded-lg shadow-2xl '>
                <div className='relative flex items-center p-3 justify-evenly border-b'>
                    <div className=' text-black font-semibold font-san'>
                        {props.title}
                    </div>                    
                    <div className=' absolute text-gray-300 top-1 right-1 cursor-pointer'>
                    <XCircleIcon className='h-9 w-9' onClick={closePopup}></XCircleIcon>                    
                    </div> 
                </div>                              
                {props.children}
            </div>  
        </div>            
    ) : "";
}

export default STPopup
